<template>
  <v-flex xs12>
    <v-layout row wrap>
      <v-flex xs12 sm6>
        <p v-if="question.Mandatory" v-html="question.QuestionText+'<font color=red> *</font>'"></p>
        <p v-else v-html="question.QuestionText"></p>
      </v-flex>
      <v-flex xs12 sm6>
        <v-textarea
          :rules="[question.Mandatory ? rules.required : true]"
          v-model="question.AnswerText"
          :label="this.$t('Enter text here')"
          filled
          multi-line>
        </v-textarea>
      </v-flex>
    </v-layout>
  </v-flex>

</template>

<script>
import rules from '@/core/mixins/common-rules'

export default {
  mixins: [rules],
  props: ['question']
}
</script>

<style>

</style>
